import { Routes } from '@angular/router';

import { setupFeatureFlagsForModule } from '@core/shared/util';
import { QUERY_PARAMS_FILTER_TOKEN, QueryParamsStoreFilterFacade } from '@mp/shared/data-access';

import { IndustriekatalogeFacade } from './facades/industriekataloge.facade';
import { PlattformkatalogeFacade } from './facades/plattformkataloge.facade';
import { PlatformkatalogeQueryParamsFilterConverterFacade } from './platformkataloge-query-params-filter-converter.facade';
import { PlattformkatalogeListComponent } from './plattformkataloge-list/plattformkataloge-list.component';

export const PLATFORM_CATALOGS_ROUTES: Routes = [
  {
    path: '',
    providers: [
      {
        provide: QUERY_PARAMS_FILTER_TOKEN,
        useClass: PlatformkatalogeQueryParamsFilterConverterFacade,
      },
      QueryParamsStoreFilterFacade,
      IndustriekatalogeFacade,
      PlattformkatalogeFacade,
    ],
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: './',
      },
      // Die drei Routen sind, damit ein Direktaufruf der Seite funktioniert. KP, warum sonst 404 kommt...
      {
        path: ':platformCatalogId',
        pathMatch: 'full',
        redirectTo: './:platformCatalogId/catalogs',
      },
      {
        path: ':platformCatalogId/catalogs',
        pathMatch: 'full',
        redirectTo: './:platformCatalogId/catalogs',
      },
      {
        path: ':platformCatalogId/organizations',
        pathMatch: 'full',
        redirectTo: './:platformCatalogId/organizations',
      },
      {
        path: './:platformCatalogId',
        component: PlattformkatalogeListComponent,
        title: 'Katalogmanagement | Plattformkataloge',
        data: setupFeatureFlagsForModule({ customHeader: true }),
        children: [
          {
            path: '',
            pathMatch: 'full',
            redirectTo: './catalogs',
          },
          {
            path: 'catalogs',
            loadComponent: async () =>
              (await import('./plattformkataloge-list/industrycatalogs-page/industry-catalogs-page.component'))
                .IndustryCatalogsPageComponent,
          },
          {
            path: 'organizations',
            loadComponent: async () =>
              (await import('./plattformkataloge-list/organizations-page/organizations-page.component'))
                .OrganizationsPageComponent,
          },
        ],
      },
    ],
  },
];
